import { TranslationFunction } from '@/i18n/types'
import z from 'zod'
import { PaymentMethod } from '../types/enums/payment-method.enum'

export const getTransferValidation = (
  t: TranslationFunction,
  walletExtra: number,
) => {
  const schema = z.object({
    paymentMethod: z.nativeEnum(PaymentMethod).refine(
      value => {
        if (value === PaymentMethod.WALLET) {
          return walletExtra <= 0
        }
        return true
      },
      {
        message: t('validation.extraPaymentReq'),
      },
    ),
    termsAccepted: z
      .boolean({
        message: t('acceptTerms.errMsg'),
      })
      .refine(v => Boolean(v), { message: t('acceptTerms.errMsg') }),
    tripId: z.string().or(z.number()),
    promoCode: z.string().optional(),
  })

  return { schema }
}
